import React from "react";
import ProfileHeader from "../profile-header/profile-header-and-breadcrumbs";
import TermsOfServiceScreen from "./terms-of-service-screen";

interface TermsOfServicePageProps {
  viewOnly?: boolean;
  headerMode?: "admin" | "provider";
  variant?: "admin" | "provider" | "preneed-planner";
}

const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({
  viewOnly = false,
  headerMode = "admin",
  variant = "admin",
}) => {
  return (
    <div>
      <ProfileHeader
        mode={headerMode}
        breadcrumbLink={[{ label: "Terms Of Service", link: "#" }]}
      />
      <TermsOfServiceScreen viewOnly={viewOnly} variant={variant} />
    </div>
  );
};

export default TermsOfServicePage;
